/* Tu match ideal · quiz v4 (rutas)
 *
 * Hasta cuatro preguntas. La primera, la prioridad, decide la ruta:
 *
 *   fuerza  → 1 prioridad · 2 base · 3 boosters · 4 ¿creatina?
 *   ambas   → 1 prioridad · 2 base · 3 boosters (creatina incluida)
 *   energia → 1 prioridad · 8 ¿proteína? (creatina incluida)
 *             con «sí» siguen 2 base · 3 boosters; con «no», solo creatina
 *
 * Los pasos son números fijos porque viajan en el enlace compartible: 1 a 4
 * y 8 son preguntas (la 8 se añadió el 2026-10-14 y por eso va fuera de
 * orden), 5 el nombre, 6 la carga y 7 el resultado.
 *
 * Cada respuesta activa un solo producto: no hay reglas cruzadas. El mapeo
 * respuesta → producto vive en los bloques de la sección, no aquí. Cada
 * producto del resultado imprime la respuesta que lo trajo.
 *
 * El estado viaja en el hash para poder compartir un resultado y volver a él.
 * El nombre no: se usa solo en el titular y no se guarda en ningún sitio.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-am-quiz]');
  if (!raiz || raiz.dataset.amQuizBound) return;
  raiz.dataset.amQuizBound = '1';

  var datos;
  try {
    datos = JSON.parse(raiz.querySelector('[data-am-quiz-data]').textContent);
  } catch (e) {
    return; // sin datos no hay quiz; el noscript ya ofrece la gama
  }

  var C = datos.copy || {};
  var escena = raiz.querySelector('[data-am-quiz-screen]');
  var zonaSheet = raiz.querySelector('[data-am-quiz-sheet]');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------- catálogo */

  var FOCOS = datos.focos || [];
  var BASES = datos.bases || [];
  var CUIDADOS = datos.cares || [];
  var RITUALES = datos.rituals || [];

  var SABORES = CUIDADOS.filter(function (c) { return c.key !== 'creatina'; });
  var CREATINA = CUIDADOS.filter(function (c) { return c.key === 'creatina'; })[0] || null;

  // El orden de las sugerencias es el inverso al de la pantalla: el último
  // sabor de la lista (el de disfrute) es el primero que se ofrece. También
  // es el que da el ritual Pausa cuando va solo.
  var PREFERIDOS = SABORES.slice().reverse();

  var PORHANDLE = {};
  CUIDADOS.concat(BASES).forEach(function (p) { if (p.handle) PORHANDLE[p.handle] = p; });

  function ritual(key) {
    return RITUALES.filter(function (r) { return r.key === key; })[0] || { key: key, name: key, tagline: '' };
  }

  // Sin respaldo a la primera base: sin respuesta no hay base.
  function baseDe(key) {
    return BASES.filter(function (b) { return b.key === key; })[0] || null;
  }

  function focoDe(key) {
    return FOCOS.filter(function (f) { return f.key === key; })[0] || null;
  }

  /* ------------------------------------------------------------- estado */

  // foco: fuerza | energia | ambas · base: clave del bloque de base ·
  // boosters: handles elegidos · nada: eligió «solo mi proteína» ·
  // crea: si | no (solo en la ruta fuerza).
  // prot: si | no (solo en la ruta energia).
  function estadoInicial() {
    return { paso: 0, foco: null, base: null, boosters: [], nada: false, crea: null, prot: null, nombre: '', edit: null, sinSug: false, sheet: false, dijo: '' };
  }
  var st = estadoInicial();

  /* -------------------------------------------------------------- rutas */

  var PREGUNTAS = [1, 2, 3, 4, 8];
  function esPregunta(paso) { return PREGUNTAS.indexOf(paso) > -1; }

  // Las preguntas que ve cada ruta, en orden. Sin prioridad elegida se
  // muestran las cuatro de fuerza; en energía, mientras no responda si
  // quiere proteína, la ruta larga (con base y boosters).
  function rutaPasos() {
    if (st.foco === 'energia') return st.prot === 'no' ? [1, 8] : [1, 8, 2, 3];
    if (st.foco === 'ambas') return [1, 2, 3];
    return [1, 2, 3, 4];
  }

  function enRuta(paso) { return rutaPasos().indexOf(paso) > -1; }

  // Después de la última pregunta de la ruta vienen el nombre (si la sección
  // lo pide), la carga y el resultado.
  function siguiente(paso) {
    var pasos = rutaPasos();
    if (paso === 0) return 1;
    var i = pasos.indexOf(paso);
    if (i > -1 && i < pasos.length - 1) return pasos[i + 1];
    if (esPregunta(paso)) return C.name_title ? 5 : 6;
    return paso + 1;
  }

  function anterior(paso) {
    var pasos = rutaPasos();
    if (paso !== 0 && !esPregunta(paso)) return pasos[pasos.length - 1];
    var i = pasos.indexOf(paso);
    return i > 0 ? pasos[i - 1] : 0;
  }

  // Cada paso nuevo es una entrada del historial, para que el botón de atrás
  // del navegador (o el gesto del iPhone) regrese a la pregunta anterior y no
  // saque de la página. `modo` dice cómo guarda pintar() el paso que pinta;
  // `indice` cuenta cuántos pasos del quiz hay detrás en el historial.
  var modo = 'replace';
  var indice = 0;
  var pasoPintado = null;

  /* ---------------------------------------------------------- utilidades */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ♀ y ♂ dibujados como SVG, igual que el snippet amara-simbolos: Poppins
     no trae esos caracteres y cada teléfono los pintaba con otra fuente. */
  var SYM_F = '<span class="am-sym" role="img" aria-label="femenino"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><circle cx="12" cy="9" r="5.5"></circle><path d="M12 14.5V22M8.5 18.5h7"></path></svg></span>';
  var SYM_M = '<span class="am-sym" role="img" aria-label="masculino"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="10" cy="14" r="5.5"></circle><path d="M14 10l6-6M15 4h5v5"></path></svg></span>';
  function sym(html) {
    return html
      .replace(/♀ /g, SYM_F + ' ').replace(/♂ /g, SYM_M + ' ')
      .replace(/♀/g, SYM_F).replace(/♂/g, SYM_M);
  }

  // El formato de la tienda es «$ {{amount}}», con espacio: se cambia por uno
  // que no se parte, para que el signo nunca quede solo al final del renglón.
  function dinero(centavos) {
    var f = datos.money || '${{amount}}';
    var v = (centavos || 0) / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, clave) {
      var dec = clave.indexOf('no_decimals') > -1 ? 0 : 2;
      var milesPunto = clave.indexOf('comma_separator') > -1;
      var partes = v.toFixed(dec).split('.');
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, milesPunto ? '.' : ',');
      return partes.join(milesPunto ? ',' : '.');
    }).replace(/ /g, '\u00a0');
  }

  function plantilla(s, mapa) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) {
      return mapa[k] != null ? mapa[k] : m;
    });
  }

  function evento(nombre, detalle) {
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(nombre, detalle || {});
      }
    } catch (e) { /* la medición nunca puede romper el quiz */ }
  }

  /* -------------------------------------------------------------- el motor */

  function motor() {
    var base = enRuta(2) && st.base ? baseDe(st.base) : null;
    var sabores = enRuta(3) ? st.boosters.map(function (h) { return PORHANDLE[h]; }).filter(Boolean) : [];

    // La creatina entra por la prioridad (energia, ambas) o por el sí de la
    // pregunta 4 en la ruta fuerza. Nunca sin que la persona lo diga. En
    // energía, la base y los boosters solo cuentan si dijo sí a la proteína
    // (con «no», 2 y 3 no están en la ruta).
    var conCrea = !!CREATINA && (st.foco === 'energia' || st.foco === 'ambas' || (st.foco === 'fuerza' && st.crea === 'si'));

    var porque = [];
    if (base && base.why) porque.push({ m: base.why, tipo: 'base', p: base });
    sabores.forEach(function (c) { if (c.why) porque.push({ m: c.why, tipo: 'care', p: c }); });
    if (conCrea) {
      var f = focoDe(st.foco);
      var motivo = st.foco === 'fuerza' ? CREATINA.why : ((f && f.why) || CREATINA.why);
      porque.push({ m: motivo, tipo: 'extra', p: CREATINA });
    }

    // Como mucho una sugerencia, fuera del match: con base y uno o dos
    // boosters, el siguiente sabor (sube el ahorro o completa un bundle).
    // La creatina no se sugiere: quien la quería ya la eligió.
    var sug = null;
    if (base && sabores.length && sabores.length < SABORES.length) {
      var falta = PREFERIDOS.filter(function (c) { return sabores.indexOf(c) === -1; })[0];
      if (falta) sug = { tipo: 'sabor', p: falta };
    }

    // El nombre del ritual: gana la primera regla que se cumple.
    var key;
    if (sabores.length >= SABORES.length && SABORES.length) key = 'pleno';
    else if (base && base.key === 'etapa') key = 'florecer';
    else if (conCrea && !sabores.length) key = 'fuerza';
    else if (sabores.length === 1 && sabores[0] === PREFERIDOS[0]) key = 'pausa';
    else if (sabores.length) key = 'raiz';
    else key = 'esencia';

    var items = [];
    if (base) items.push(base);
    items = items.concat(sabores);
    if (conCrea) items.push(CREATINA);

    return {
      base: base, sabores: sabores, crea: conCrea, sug: sug, porque: porque,
      ritual: ritual(key), conCreatina: conCrea && key !== 'fuerza', items: items
    };
  }

  /* --------------------------------------------------------------- precios */

  function precio(items) {
    var nSabores = items.filter(function (p) { return p.key === 'booster'; }).length;
    var hayBase = items.some(function (p) { return p.tipo === 'base'; });
    var sub = items.reduce(function (a, p) { return a + (p.price || 0); }, 0);
    var off = 0;
    if (hayBase && nSabores) {
      var t = (datos.tiers || []).filter(function (x) { return x.n === nSabores; })[0];
      off = t ? t.off : 0;
    }
    var clave = items.map(function (p) { return p.handle; }).sort().join('|');
    var pack = (datos.packs || []).filter(function (p) {
      return p.components.slice().sort().join('|') === clave;
    })[0] || null;
    var total = pack ? pack.price : sub - off;
    return { sub: sub, total: total, ahorro: sub - total, pack: pack, sabores: nSabores };
  }

  function ritualActual() {
    var r = motor();
    if (!st.edit) st.edit = r.items.map(function (p) { return p.handle; });
    var items = st.edit.map(function (h) { return PORHANDLE[h]; }).filter(Boolean);
    return { r: r, items: items, c: precio(items) };
  }

  /* ----------------------------------------------------------------- vaso */

  var contado = false;
  var nVaso = 0;
  var PESO = { base: 34, booster: 18, creatina: 14 };

  // Del fondo (104) al borde (9) caben 95 unidades. Con cinco capas suman
  // 102 y la de arriba quedaba cortada: si no caben, se escalan todas por
  // igual y el vaso queda lleno hasta 2 unidades bajo el borde.
  var CABE = 93;

  function vaso(items, ancho) {
    var id = 'amv' + (++nVaso);
    var alto = Math.round(ancho * 104 / 80);
    var pesos = items.map(function (p) { return PESO[p.tipo === 'base' ? 'base' : p.key] || 14; });
    var suma = pesos.reduce(function (a, h) { return a + h; }, 0);
    var escala = suma > CABE ? CABE / suma : 1;
    var y = 104;
    var capas = items.map(function (p, i) {
      var h = Math.round(pesos[i] * escala * 10) / 10;
      y = Math.round((y - h) * 10) / 10;
      return '<rect x="0" y="' + y + '" width="80" height="' + h + '" fill="' + esc(p.color || '#b8c497') + '"></rect>';
    }).join('');
    return '<svg class="am-rq__vaso" width="' + ancho + '" height="' + alto + '" viewBox="0 0 80 104" fill="none" aria-hidden="true" focusable="false">' +
      (capas ? '<defs><clipPath id="' + id + '"><path d="M15 9h50l-5.5 81a10 10 0 0 1-10 9.2H30.5a10 10 0 0 1-10-9.2z"></path></clipPath></defs>' +
        '<g clip-path="url(#' + id + ')">' + capas + '</g>' : '') +
      '<path d="M15 9h50l-5.5 81a10 10 0 0 1-10 9.2H30.5a10 10 0 0 1-10-9.2z" stroke="#232b22" stroke-opacity=".45" stroke-width="1.8"></path>' +
      '<path d="M12.5 9h55" stroke="#232b22" stroke-opacity=".45" stroke-width="1.8" stroke-linecap="round"></path>' +
      '</svg>';
  }

  // Lo que ya lleva el match mientras se contesta, para que el vaso crezca
  // de menos a más: vacío en la pregunta 1 y una capa más con cada respuesta.
  function parciales() {
    if (!st.foco) return [];
    return motor().items;
  }

  // La entrada enseña el vaso completo, con todas las capas posibles: la
  // promesa de lo que se va a armar. Se decidió así el 22-sep (S69); vacío
  // en la entrada no gustó.
  function vasoLleno() {
    return (BASES[0] ? [BASES[0]] : []).concat(SABORES, CREATINA ? [CREATINA] : []);
  }

  /* ------------------------------------------------------------- plantillas */

  var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"></path></svg>';

  function barra(conProgreso, pasoActual) {
    var salida = '<a class="am-rq__escape" href="' + esc(C.escape_url || '/') + '" data-salir>' + esc(C.escape) + '</a>';
    if (!conProgreso) return '<div class="am-rq__top am-rq__top--solo">' + salida + '</div>';
    var mini = '<span class="am-rq__vaso-mini">' + vaso(parciales(), 40) + '</span>';
    // La barra enseña solo los pasos de la ruta elegida.
    var pasos = rutaPasos();
    var actual = pasos.indexOf(pasoActual);
    var capas = pasos.map(function (n, i) {
      var cls = i < actual ? 'is-done' : (i === actual ? 'is-now' : '');
      var rotulo = n === 8 ? C.l_prot : (C.labels || [])[n - 1];
      return '<li class="' + cls + '">' + esc(rotulo || '') + '</li>';
    }).join('');
    return '<div class="am-rq__top am-rq__top--prog">' + mini +
      '<ol class="am-rq__prog" style="--pasos:' + pasos.length + '">' + capas + '</ol>' + salida + '</div>';
  }

  function opcion(o) {
    return '<button type="button" class="am-rq__opt' + (o.on ? ' is-on' : '') + (o.dim ? ' is-dim' : '') + '"' +
      ' aria-pressed="' + (o.on ? 'true' : 'false') + '" data-pick="' + esc(o.valor) + '">' +
      '<span class="am-rq__mark' + (o.multi ? ' am-rq__mark--box' : '') + '" aria-hidden="true">' + (o.on ? CHECK : '') + '</span>' +
      '<span class="am-rq__opt-body">' +
        '<span class="am-rq__opt-t">' + sym(esc(o.t)) + '</span>' +
        (o.d ? '<span class="am-rq__opt-d">' + sym(esc(o.d)) + '</span>' : '') +
      '</span>' +
      (o.tag ? '<span class="am-rq__tag' + (o.tone ? ' am-rq__tag--' + esc(o.tone) : '') + '">' + esc(o.tag) + '</span>' : '') +
      '</button>';
  }

  // El pie (si la pregunta tiene botón) va dentro de la columna de las
  // opciones: en escritorio queda bajo ellas, donde está la mirada, y en
  // móvil sigue fijo abajo. La frase de respuesta se pinta siempre, vacía
  // hasta que se elige, para que su llegada no mueva la pantalla.
  function pantallaPregunta(n, titulo, ayuda, opciones, pie, multi, extra) {
    return barra(true, n) +
      '<div class="am-rq__body am-rq__body--pregunta">' +
        '<div class="am-rq__ask"><span class="am-rq__vaso-ask">' + vaso(parciales(), 148) + '</span>' +
          '<div class="am-rq__head">' +
            '<h1 class="am-rq__q">' + esc(titulo) + '</h1>' +
            (ayuda ? '<p class="am-rq__help">' + esc(ayuda) + '</p>' : '') +
          '</div>' +
        '</div>' +
        '<div class="am-rq__col">' +
          '<div class="am-rq__opts' + (multi ? ' am-rq__opts--multi' : '') + '">' + opciones + '</div>' +
          '<p class="am-rq__say">' + esc(st.dijo) + '</p>' +
          (extra || '') +
          (pie || '<button type="button" class="am-rq__link am-rq__link--gris am-rq__atras" data-nav="atras">' + esc(C.cta_back) + '</button>') +
        '</div>' +
      '</div>';
  }

  /* ----------------------------------------------------------- las pantallas */

  function pintar() {
    var html = '';

    if (st.paso === 0) {
      html = barra(false) +
        '<div class="am-rq__centro">' + vaso(vasoLleno(), 128) +
          '<div class="am-rq__centro-texto">' +
            '<span class="am-rq__eyebrow">' + esc(C.intro_eyebrow) + '</span>' +
            '<h1 class="am-rq__hero">' + esc(C.intro_title) + '</h1>' +
            '<p class="am-rq__lead">' + esc(C.intro_text) + '</p>' +
          '</div>' +
        '</div>' +
        '<div class="am-rq__foot am-rq__foot--centro"><button type="button" class="am-rq__btn" data-nav="empezar">' + esc(C.cta_start) + '</button></div>';

    } else if (st.paso === 1) {
      html = pantallaPregunta(1, C.q1, C.q1_help,
        FOCOS.map(function (f) {
          return opcion({ t: f.answer, d: f.detail, valor: f.key, on: st.foco === f.key, dim: st.foco != null && st.foco !== f.key });
        }).join(''),
        '');

    } else if (st.paso === 2) {
      html = pantallaPregunta(2, C.q2, C.q2_help,
        BASES.map(function (b) {
          return opcion({ t: b.answer, d: b.detail, valor: b.key, on: st.base === b.key, dim: st.base != null && st.base !== b.key });
        }).join(''),
        '');

    } else if (st.paso === 3) {
      var algo = st.boosters.length > 0;
      var todos = SABORES.length > 0 && st.boosters.length >= SABORES.length;
      html = pantallaPregunta(3, C.q3, C.q3_help,
        SABORES.map(function (c) {
          return opcion({ t: c.answer, d: c.detail, tag: c.tag, tone: c.tone, valor: c.handle, multi: true, on: st.boosters.indexOf(c.handle) > -1 });
        }).join('') +
        opcion({ t: C.q3_all, d: C.q3_all_d, valor: 'todos', multi: true, on: todos }) +
        opcion({ t: C.q3_none, d: C.q3_none_d, valor: 'nada', multi: true, on: st.nada === true, dim: algo && !st.nada }),
        pieSeguir(C.cta_next, algo || st.nada === true), true);

    } else if (st.paso === 4) {
      // Una ficha breve de la creatina, plegada, sin añadir otra pregunta.
      var info = C.c_more
        ? '<details class="am-rq__info"><summary>' + esc(C.c_more) + '</summary><p>' + esc(C.c_more_text) + '</p></details>'
        : '';
      html = pantallaPregunta(4, C.q4, C.q4_help,
        opcion({ t: C.c_yes, d: C.c_yes_d, valor: 'si', on: st.crea === 'si', dim: st.crea != null && st.crea !== 'si' }) +
        opcion({ t: C.c_no, d: C.c_no_d, valor: 'no', on: st.crea === 'no', dim: st.crea != null && st.crea !== 'no' }),
        '', false, info);

    } else if (st.paso === 8) {
      // Ruta energía: la creatina ya va; aquí se decide si lleva proteína.
      html = pantallaPregunta(8, C.q5, C.q5_help,
        opcion({ t: C.p_yes, d: C.p_yes_d, valor: 'si', on: st.prot === 'si', dim: st.prot != null && st.prot !== 'si' }) +
        opcion({ t: C.p_no, d: C.p_no_d, valor: 'no', on: st.prot === 'no', dim: st.prot != null && st.prot !== 'no' }),
        '');

    } else if (st.paso === 5) {
      // Un solo botón: el campo ya dice que el nombre es opcional, y con el
      // campo vacío «Saltar» hacía exactamente lo mismo que «Ver mi match».
      html = barra(false) +
        '<div class="am-rq__centro">' + vaso(parciales(), 104) +
          '<div class="am-rq__centro-texto">' +
            '<span class="am-rq__eyebrow">' + esc(C.name_eyebrow) + '</span>' +
            '<h1 class="am-rq__hero am-rq__hero--sm">' + esc(C.name_title) + '</h1>' +
          '</div>' +
          '<input class="am-rq__campo" id="am-rq-nombre" type="text" maxlength="24" autocomplete="given-name" enterkeyhint="go" placeholder="' + esc(C.name_placeholder) + '" value="' + esc(st.nombre) + '" aria-label="' + esc(C.name_placeholder) + '">' +
        '</div>' +
        '<div class="am-rq__foot am-rq__foot--centro">' +
          '<button type="button" class="am-rq__btn" data-nav="ver">' + esc(C.cta_see) + '</button>' +
          '<button type="button" class="am-rq__link am-rq__link--gris" data-nav="atras">' + esc(C.cta_back) + '</button>' +
        '</div>';

    } else if (st.paso === 6) {
      html = '<div class="am-rq__centro">' + vaso(parciales(), 150) +
        '<div class="am-rq__cargando" aria-live="polite">' +
          [C.load_1, C.load_2, C.load_3].map(function (l, i) {
            return '<span class="' + (i === 0 ? 'is-now' : '') + '" data-load="' + i + '">' + esc(l) + '</span>';
          }).join('') +
        '</div></div>';

    } else {
      html = pantallaResultado();
    }

    // Repintar destruye el botón que tenía el foco. Si la pantalla es la
    // misma (se marcó una opción), el foco vuelve al mismo control; si no,
    // se va al titular de la pantalla nueva.
    var clave = claveFoco(escena);
    var mismoPaso = st.paso === pasoPintado;

    escena.innerHTML = html;
    raiz.dataset.paso = st.paso;
    if (st.paso === 7 && !contado) {
      contado = true;
      var fin = ritualActual();
      evento('quiz_complete', {
        ritual: fin.r.ritual.key, productos: fin.items.length, total: fin.c.total / 100,
        bundle: fin.c.pack ? fin.c.pack.title : null, con_nombre: !!st.nombre.trim()
      });
    }
    if (st.paso === 6) correCarga();

    var campo = document.getElementById('am-rq-nombre');
    if (mismoPaso) {
      devolverFoco(escena, clave);
    } else if (pasoPintado !== null) {
      llevarArriba();
      if (!campo) {
        var titular = escena.querySelector('h1');
        if (titular) {
          titular.setAttribute('tabindex', '-1');
          titular.focus({ preventScroll: true });
        }
      }
    }
    pasoPintado = st.paso;

    if (campo) {
      campo.addEventListener('input', function () { st.nombre = campo.value; });
      campo.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter') { ev.preventDefault(); st.nombre = campo.value; avanza(); }
      });
      if (!reduce) campo.focus({ preventScroll: true });
    }
    pintarSheet();
    guardar();
    fijarColumna();
  }

  // En escritorio la columna del nombre se queda fija al bajar. Si es más
  // alta que la ventana, fijarla por arriba escondería su parte baja (el
  // botón y las acciones) hasta el final de la página; se fija entonces por
  // abajo: sube lo justo para que se vea entera y ahí se queda.
  function fijarColumna() {
    var col = escena.querySelector('.am-rq__res-izq');
    if (!col) return;
    var margen = 16;
    col.style.top = Math.min(margen, window.innerHeight - col.offsetHeight - margen) + 'px';
  }
  // Cuánto ocupa lo que hay encima del quiz (la cabecera): la entrada, el
  // nombre y la carga llenan justo el resto de la ventana (ver el CSS).
  function medirArriba() {
    raiz.style.setProperty('--rq-arriba', Math.round(raiz.getBoundingClientRect().top + window.pageYOffset) + 'px');
  }

  // La cabecera anima su altura (transition: all): se mide al momento y otra
  // vez cuando termina la animación.
  var reMedida = null;
  window.addEventListener('resize', function () {
    medirArriba(); fijarColumna();
    clearTimeout(reMedida);
    reMedida = setTimeout(function () { medirArriba(); fijarColumna(); }, 450);
  });
  // Las tipografías cambian la altura al cargar: se vuelve a medir.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { medirArriba(); fijarColumna(); });

  function claveFoco(zona) {
    var a = document.activeElement;
    if (!a || !zona.contains(a) || !a.dataset) return null;
    var attrs = ['pick', 'nav', 'toggle', 'swap', 'sumar'];
    for (var i = 0; i < attrs.length; i++) {
      if (a.dataset[attrs[i]] != null) return { attr: attrs[i], valor: a.dataset[attrs[i]] };
    }
    return null;
  }

  function devolverFoco(zona, clave) {
    if (!clave) return;
    var nombre = 'data-' + clave.attr;
    var el = [].filter.call(zona.querySelectorAll('[' + nombre + ']'), function (x) {
      return x.getAttribute(nombre) === clave.valor;
    })[0];
    if (el) el.focus({ preventScroll: true });
  }

  // Al cambiar de pantalla, si el principio del quiz quedó por encima de la
  // ventana (la persona bajó para tocar la última opción), se sube hasta él:
  // si no, la pregunta nueva aparece con el titular fuera de la vista.
  function llevarArriba() {
    var cabecera = document.querySelector('.am-header-section, .section-header');
    var fija = cabecera && /sticky|fixed/.test(getComputedStyle(cabecera).position) ? cabecera.offsetHeight : 0;
    var arriba = raiz.getBoundingClientRect().top;
    if (arriba >= fija) return;
    window.scrollTo({ top: Math.max(0, arriba + window.pageYOffset - fija), behavior: reduce ? 'auto' : 'smooth' });
  }

  // El pie de la pregunta de selección múltiple: «Atrás» a la izquierda y el
  // botón a la derecha, en la misma franja.
  function pieSeguir(rotulo, listo) {
    return '<div class="am-rq__foot am-rq__foot--linea am-rq__foot--fila">' +
      '<button type="button" class="am-rq__link am-rq__link--gris" data-nav="atras">' + esc(C.cta_back) + '</button>' +
      '<button type="button" class="am-rq__btn" data-nav="seguir"' + (listo ? '' : ' disabled') + '>' + esc(rotulo) + '</button>' +
      '</div>';
  }

  function correCarga() {
    if (reduce) { st.paso = 7; pintar(); return; }
    var i = 0;
    var t = setInterval(function () {
      // Si la persona volvió atrás durante la carga, la carga se abandona.
      if (st.paso !== 6) { clearInterval(t); return; }
      i++;
      var lineas = escena.querySelectorAll('[data-load]');
      [].forEach.call(lineas, function (l, k) { l.className = k === i ? 'is-now' : ''; });
      if (i >= lineas.length) { clearInterval(t); st.paso = 7; pintar(); }
    }, 600);
  }

  /* -------------------------------------------------------------- resultado */

  // El nombre de cada producto lleva a su ficha en otra pestaña: el match
  // armado (con sus ajustes y el nombre) no viaja en el enlace y se perdería
  // al volver.
  function nombreProducto(p, conSignos) {
    var texto = esc(p.emoji || '') + ' ' + esc(p.title) + (conSignos && p.sym ? ' ' + sym(esc(p.sym)) : '');
    if (!p.url) return '<span class="am-rq__prod">' + texto + '</span>';
    return '<a class="am-rq__prod am-rq__prod--link" href="' + esc(p.url) + '" target="_blank" rel="noopener">' + texto +
      '<span class="am-rq__oculto"> (' + esc(C.r_new_tab) + ')</span></a>';
  }

  function fichaProducto(p, compacta) {
    if (compacta) {
      return '<div class="am-rq__fila">' +
        '<span class="am-rq__barra" style="background:' + esc(p.color) + '"></span>' +
        '<span class="am-rq__fila-body">' +
          nombreProducto(p, false) +
          '<span class="am-rq__fila-sub">' + esc(p.role) + (p.sabor ? ' · ' + esc(p.sabor) : '') + '</span>' +
        '</span></div>';
    }
    return '<div class="am-rq__ficha">' +
      (p.image
        ? '<img class="am-rq__thumb" src="' + esc(p.image) + '" alt="" width="56" height="66" loading="lazy" style="background:' + esc(p.tint || '#f7f2ed') + '">'
        : '<span class="am-rq__thumb" style="background:' + esc(p.tint || '#f7f2ed') + '"></span>') +
      '<span class="am-rq__ficha-body">' +
        '<span class="am-rq__rol">' + esc(p.role) + '</span>' +
        nombreProducto(p, true) +
        '<span class="am-rq__linea">' + esc(p.line) + '</span>' +
      '</span></div>';
  }

  function bloquePrecio(c) {
    var filas = '';
    if (c.ahorro > 0) {
      filas += '<div><span>' + esc(C.r_sep) + '</span><span>' + dinero(c.sub) + '</span></div>' +
        '<div class="is-off"><span>' + esc(c.pack ? plantilla(C.r_as, { n: c.pack.title }) : C.r_save) + '</span><span>−' + dinero(c.ahorro) + '</span></div>';
    }
    return '<div class="am-rq__precio">' + filas +
      '<div class="is-total"><span>' + esc(C.r_total) + '</span><strong>' + dinero(c.total) + '</strong></div></div>';
  }

  // La sugerencia que sube el ahorro, resumida junto al botón de añadir, que
  // es donde se decide la compra. Va debajo del botón para no bajarlo. Solo
  // en escritorio: en móvil la caja completa va justo después del precio.
  function bloqueOferta(oferta) {
    if (!oferta) return '';
    return '<div class="am-rq__oferta">' +
      '<button type="button" class="am-rq__btn am-rq__btn--out am-rq__btn--sm" data-sumar="' + esc(oferta.p.handle) + '">' +
        esc(rotuloSumar(oferta.p, oferta.diff)) + '</button>' +
      '<p>' + esc(oferta.texto) + '</p>' +
    '</div>';
  }

  // El botón de sumar un producto dice cuánto sube el total. Si no sube
  // (sumarlo completa un bundle que cuesta lo mismo o menos que lo que ya
  // lleva), va sin cifra: «· $ -1.00» se leía como un error y «· $ 1.00
  // menos» tampoco se entendía. El ahorro ya lo dice la frase de abajo.
  function rotuloSumar(p, diff) {
    if (diff <= 0) return plantilla(C.sug_add_free || 'Sumar [p] sin pagar más', { p: p.title });
    return plantilla(C.sug_add, { p: p.title }) + ' · ' + dinero(diff);
  }

  function textoSube(c, c2) {
    if (c.ahorro > 0) return plantilla(C.sug_up, { a: dinero(c.ahorro), b: dinero(c2.ahorro) });
    return C.r_save + ' ' + dinero(c2.ahorro) + '.';
  }

  function textoSugerencia(sug, c, c2) {
    var t = plantilla(C.sug_f_text, { p: sug.p.title, s: sug.p.sabor });
    if (c2.ahorro > c.ahorro && !c2.pack) t += ' ' + textoSube(c, c2);
    if (c2.pack) {
      t += ' ' + plantilla(C.sug_bundle, { n: c2.pack.title }) +
        (c2.ahorro > c.ahorro ? ' ' + textoSube(c, c2) : '');
    }
    return t;
  }

  function pantallaResultado() {
    var x = ritualActual();
    var r = x.r, items = x.items, c = x.c;
    var compacta = items.length >= 5;
    var nombre = st.nombre.trim();

    var baseActual = items.filter(function (p) { return p.tipo === 'base'; })[0];
    var lista = r.porque.slice();
    if (baseActual && r.base && baseActual.handle !== r.base.handle) {
      lista = lista.filter(function (q) { return q.tipo !== 'base'; });
      lista.unshift({ m: C.r_why_swapped, tipo: 'base', p: baseActual, suelto: true });
    }
    var porques = lista.filter(function (q) {
      return q.m && items.indexOf(q.p) > -1;
    }).map(function (q) {
      var cola = q.tipo === 'base' ? plantilla(C.r_why_base, { p: q.p.title })
        : q.tipo === 'extra' ? C.r_why_extra
        : plantilla(C.r_why_care, { p: q.p.title });
      return '<li>' + esc(q.m) + esc(C.r_why_join) + ' ' + esc(cola) + '</li>';
    }).join('');

    // La sugerencia solo sigue en pie si lo que ofrece no está ya en el ritual.
    var sug = r.sug;
    if (sug && (st.sinSug || items.some(function (p) { return p.handle === sug.p.handle; }))) sug = null;

    // Un solo botón lleno en el resultado, el de añadir: el de la sugerencia
    // va con contorno y «Así está bien» es un enlace.
    var cajaSug = '';
    var oferta = null;
    if (sug) {
      var c2 = precio(items.concat([sug.p]));
      cajaSug = '<div class="am-rq__sug">' +
        '<span class="am-rq__sug-t">' + esc(C.sug_f_title) + '</span>' +
        '<p>' + esc(textoSugerencia(sug, c, c2)) + '</p>' +
        '<div class="am-rq__sug-acc">' +
          '<button type="button" class="am-rq__btn am-rq__btn--out" data-sumar="' + esc(sug.p.handle) + '">' +
            esc(rotuloSumar(sug.p, c2.total - c.total)) + '</button>' +
          '<button type="button" class="am-rq__link am-rq__link--gris" data-nav="sin-sug">' + esc(C.sug_no) + '</button>' +
        '</div>' +
      '</div>';
      // Junto al precio solo se repite si mejora el trato: si sube el ahorro
      // o completa un bundle. La creatina sin bundle no pasa por aquí: su
      // motivo necesita la caja entera.
      if (c2.ahorro > c.ahorro) {
        oferta = {
          p: sug.p,
          diff: c2.total - c.total,
          texto: (c2.pack ? plantilla(C.sug_bundle, { n: c2.pack.title }) + ' ' : '') + textoSube(c, c2)
        };
      }
    } else if (items.length === 1) {
      cajaSug = '<div class="am-rq__caja"><p>' + esc(C.r_simple) + '</p></div>';
    }

    // Cambiar de base solo tiene sentido si hay base: el match de energía y
    // concentración es solo creatina.
    var otra = baseActual ? BASES.filter(function (b) { return b.handle !== baseActual.handle; })[0] : null;

    var agotado = items.some(function (p) { return p.available === false; });
    // Los boosters no se suman en un vaso: son alternativas de día. Con uno
    // solo va dentro de la frase; con varios, se listan aparte como opciones.
    var laBase = baseActual && baseActual.prep ? baseActual.prep : '';
    var losSabores = items.filter(function (p) { return p.key === 'booster' && p.prep; }).map(function (p) { return p.prep; });
    var laCreatina = items.filter(function (p) { return p.key === 'creatina'; })[0];
    var prepTexto = '';
    if (laBase) {
      prepTexto = laBase;
      if (losSabores.length === 1) prepTexto += ' ' + plantilla(C.r_prep_with, { p: losSabores[0] });
      prepTexto += ' ' + C.r_prep_tail;
      if (losSabores.length > 1) {
        var lista = losSabores.slice(0, -1).join(', ') + ' ' + C.r_prep_or + ' ' + losSabores[losSabores.length - 1];
        prepTexto += ' ' + plantilla(C.r_prep_day, { p: lista });
      }
      if (laCreatina) prepTexto += ' ' + C.r_prep_creatine;
    } else if (laCreatina) {
      prepTexto = C.r_prep_creatine;
    }

    return barra(false) +
      '<div class="am-rq__res">' +
        '<div class="am-rq__res-izq">' +
          '<div class="am-rq__res-top">' + vaso(items, 150) +
            '<span class="am-rq__eyebrow">' + esc(nombre ? plantilla(C.r_eyebrow_name, { n: nombre }) : C.r_eyebrow) + '</span>' +
            '<h1 class="am-rq__nombre">' + esc(r.ritual.name) + '</h1>' +
            (r.conCreatina ? '<span class="am-rq__mod">' + esc(C.r_mod) + '</span>' : '') +
            '<p class="am-rq__tagline">' + esc(r.ritual.tagline) + '</p>' +
          '</div>' +
          '<div class="am-rq__res-cta">' +
            bloquePrecio(c) +
            '<div class="am-rq__cta">' +
              (agotado
                ? '<p class="am-rq__aviso">' + esc(C.r_sold_out) + '</p>'
                : '<button type="button" class="am-rq__btn" data-add>' + esc(plantilla(C.r_cta, { total: dinero(c.total) })) + '</button>') +
            '</div>' +
            bloqueOferta(oferta) +
            '<div class="am-rq__acciones">' +
              '<button type="button" class="am-rq__link" data-nav="ajustar">' + esc(C.r_adjust) + '</button>' +
              '<button type="button" class="am-rq__link am-rq__link--gris" data-nav="reiniciar">' + esc(C.r_restart) + '</button>' +
              '<button type="button" class="am-rq__link am-rq__link--gris" data-nav="compartir">' + esc(C.r_share) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<div class="am-rq__res-der">' +
          (porques ? '<div class="am-rq__bloque am-rq__bloque--porque"><span class="am-rq__label">' + esc(C.r_why) + '</span><ul class="am-rq__porques">' + porques + '</ul></div>' : '') +
          '<div class="am-rq__bloque am-rq__bloque--lleva">' +
            '<span class="am-rq__label">' + esc(C.r_items) + '</span>' +
            '<div class="am-rq__fichas">' + items.map(function (p) { return fichaProducto(p, compacta); }).join('') + '</div>' +
            (otra ? '<button type="button" class="am-rq__link" data-swap="' + esc(otra.handle) + '">' + esc(otra.swap) + '</button>' : '') +
          '</div>' +
          (cajaSug ? '<div class="am-rq__bloque am-rq__bloque--sug">' + cajaSug + '</div>' : '') +
          (c.pack
            ? '<div class="am-rq__bloque am-rq__bloque--pack"><div class="am-rq__caja">' +
                '<span class="am-rq__caja-t">' + esc(C.r_bundle_t) + '</span>' +
                '<span class="am-rq__caja-n">' + esc(c.pack.title) + '</span>' +
                '<p>' + esc(C.r_bundle_d) + '</p></div></div>'
            : '') +
          (prepTexto
            ? '<div class="am-rq__bloque am-rq__bloque--prep"><span class="am-rq__label">' + esc(C.r_prep) + '</span><p class="am-rq__prep">' + esc(prepTexto) + '</p></div>'
            : '') +
        '</div>' +
      '</div>';
  }

  /* ---------------------------------------------------------- hoja de ajuste */

  function pintarSheet() {
    if (!zonaSheet) return;
    if (!st.sheet || st.paso !== 7) { zonaSheet.innerHTML = ''; zonaSheet.hidden = true; return; }

    var x = ritualActual();
    var todos = x.r.items.slice();
    // Lo que la persona sumó a mano (una sugerencia aceptada) también se apaga.
    x.items.forEach(function (p) { if (todos.indexOf(p) === -1) todos.push(p); });
    // Y lo que el match no trae se puede encender: la hoja sirve para quitar
    // y para añadir, no solo para quitar.
    CUIDADOS.forEach(function (p) { if (todos.indexOf(p) === -1) todos.push(p); });
    // Sin base (solo creatina), las dos proteínas se ofrecen arriba: el
    // resultado dice «cuando quieras sumarle algo, ajústalo aquí mismo» y la
    // hoja no dejaba sumar una. Con base, solo la que lleva: si se cambió,
    // la anterior no se queda como un interruptor apagado sin uso.
    var conBase = x.items.some(function (p) { return p.tipo === 'base'; });
    if (!conBase) todos = BASES.filter(function (b) { return todos.indexOf(b) === -1; }).concat(todos);
    todos = todos.filter(function (p) { return p.tipo !== 'base' || !conBase || x.items.indexOf(p) > -1; });
    // La base del match no se apaga; una sumada aquí, sí.
    var baseDelMatch = x.r.items.some(function (p) { return p.tipo === 'base'; });

    var filas = todos.map(function (p) {
      var on = st.edit.indexOf(p.handle) > -1;
      // La base no se apaga, y tampoco lo último que queda encendido: en la
      // ruta de energía el match es solo la creatina, y apagarla dejaba un
      // resultado vacío con «Añadir mi match · $0.00» que no hacía nada.
      var fijo = (p.tipo === 'base' && baseDelMatch) || (on && st.edit.length === 1);
      return '<button type="button" class="am-rq__sw' + (on ? '' : ' is-off') + '"' +
        (fijo ? ' disabled' : ' data-toggle="' + esc(p.handle) + '"') + ' aria-pressed="' + (on ? 'true' : 'false') + '">' +
        '<span class="am-rq__barra" style="background:' + esc(p.color) + '"></span>' +
        '<span class="am-rq__fila-body">' +
          '<span class="am-rq__prod">' + esc(p.emoji || '') + ' ' + esc(p.title) + '</span>' +
          '<span class="am-rq__fila-sub">' + esc(p.role) + ' · ' + dinero(p.price) + '</span>' +
        '</span>' +
        '<span class="am-rq__sw-track" aria-hidden="true"><span></span></span>' +
      '</button>';
    }).join('');

    var baseHoja = x.items.filter(function (p) { return p.tipo === 'base'; })[0];
    var otra = baseHoja ? BASES.filter(function (b) { return b.handle !== baseHoja.handle; })[0] : null;
    var antes = precio(x.r.items);

    var abierta = !zonaSheet.hidden;
    var clave = claveFoco(zonaSheet);
    zonaSheet.hidden = false;
    zonaSheet.innerHTML = '<div class="am-rq__sheet" data-cerrar-fondo>' +
      '<div class="am-rq__sheet-panel" role="dialog" aria-modal="true" aria-label="' + esc(C.r_adjust) + '" tabindex="-1">' +
        '<span class="am-rq__grip" aria-hidden="true"></span>' +
        '<button type="button" class="am-rq__cerrar" data-nav="cerrar-ajuste" aria-label="' + esc(C.adj_close) + '">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"></path></svg>' +
        '</button>' +
        '<div class="am-rq__sheet-head"><h2>' + esc(C.r_adjust) + '</h2>' +
          '<span class="am-rq__sheet-note">' + esc(plantilla(C.adj_note, { n: x.r.ritual.name })) + '</span></div>' +
        '<div class="am-rq__sheet-list">' + filas +
          (otra ? '<button type="button" class="am-rq__link" data-swap="' + esc(otra.handle) + '">' + esc(otra.swap) + '</button>' : '') +
        '</div>' +
        '<div class="am-rq__sheet-total"><span>' + esc(C.r_total) + '</span>' +
          '<span>' + (antes.total !== x.c.total ? '<em>' + dinero(antes.total) + '</em>' : '') +
          '<strong>' + dinero(x.c.total) + '</strong></span></div>' +
        '<div class="am-rq__sheet-foot"><button type="button" class="am-rq__btn" data-nav="cerrar-ajuste">' + esc(C.adj_save) + '</button></div>' +
      '</div></div>';

    // Al abrir, el foco entra en la hoja; al repintarla, vuelve al interruptor
    // que se tocó.
    if (!abierta) zonaSheet.querySelector('.am-rq__sheet-panel').focus({ preventScroll: true });
    else devolverFoco(zonaSheet, clave);
  }

  function cerrarHoja() {
    st.sheet = false;
    pintar();
    var b = escena.querySelector('[data-nav="ajustar"]');
    if (b) b.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------- hash compartible */

  // Un paso nuevo se apila en el historial; una respuesta dentro del mismo
  // paso solo reescribe la entrada actual. La carga no se guarda: no es un
  // sitio al que se pueda volver.
  function guardar() {
    if (st.paso === 6) return;
    var url = '#m=' + [st.foco || '', st.base || '', st.boosters.join('.'), st.nada ? '1' : '', st.crea || '', st.paso, st.prot || ''].join('~');
    try {
      if (modo === 'push') { indice += 1; history.pushState({ amq: indice }, '', url); }
      else history.replaceState({ amq: indice }, '', url);
    } catch (e) { /* da igual */ }
    modo = 'replace';
  }

  // El formato es #m=prioridad~base~boosters~nada~creatina~paso~proteína.
  // La proteína (séptimo campo) se añadió el 2026-10-14: los enlaces de
  // antes tienen seis y siguen valiendo. Los del quiz anterior (#r=) no se
  // leen: se empieza de cero.
  function hashPartes() {
    var m = /#m=([^&]*)/.exec(location.hash);
    if (!m) return null;
    var p = m[1].split('~');
    return p.length < 6 ? null : p;
  }

  function respondida(n) {
    if (n === 1) return !!focoDe(st.foco);
    if (n === 2) return !!baseDe(st.base);
    if (n === 3) return st.boosters.length > 0 || st.nada;
    if (n === 4) return st.crea === 'si' || st.crea === 'no';
    if (n === 8) return st.prot === 'si' || st.prot === 'no';
    return true;
  }

  // Nunca se llega a un paso sin haber contestado los anteriores de su ruta,
  // ni a una pregunta que no es de la ruta elegida.
  // Se compara por la posición en la ruta y no por el número: la pregunta
  // 8 va antes que la 2 en la ruta de energía.
  function pasoPosible(paso) {
    if (!(paso >= 0 && paso <= 8)) paso = 0;
    if (paso === 6) paso = 7;
    if (paso === 0) return 0;
    var pasos = rutaPasos();
    var falta = pasos.filter(function (n) { return !respondida(n); })[0];
    var pos = esPregunta(paso) ? pasos.indexOf(paso) : pasos.length;
    if (esPregunta(paso) && pos === -1) return falta != null ? falta : (C.name_title ? 5 : 7);
    if (falta != null && pasos.indexOf(falta) < pos) return falta;
    if (paso === 5 && !C.name_title) return 7;
    return paso;
  }

  function leer() {
    var p = hashPartes();
    if (!p) return;
    if (focoDe(p[0])) st.foco = p[0];
    if (baseDe(p[1])) st.base = p[1];
    st.boosters = p[2].split('.').filter(function (h) { return PORHANDLE[h] && PORHANDLE[h].key === 'booster'; });
    st.nada = p[3] === '1' && !st.boosters.length;
    if (p[4] === 'si' || p[4] === 'no') st.crea = p[4];
    if (p[6] === 'si' || p[6] === 'no') st.prot = p[6];
    // Un enlace de energía de antes de la pregunta de proteína era solo
    // creatina: se respeta, en vez de mandarlo a una pregunta nueva.
    else if (p.length === 6 && st.foco === 'energia') st.prot = 'no';
    st.paso = pasoPosible(parseInt(p[5], 10));
  }

  // Atrás y adelante del navegador: solo cambia el paso. Las respuestas se
  // quedan como están, que son las más recientes.
  window.addEventListener('popstate', function (ev) {
    indice = ev.state && ev.state.amq ? ev.state.amq : 0;
    var p = hashPartes();
    st.dijo = '';
    st.edit = null;
    st.sheet = false;
    st.paso = pasoPosible(p ? parseInt(p[5], 10) : 0);
    pintar();
  });

  /* ------------------------------------------------------------- al carrito */

  function rutaBase() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Guarda en el carrito de qué match viene la compra (2026-10-02). Son
  // atributos del carrito: pasan al pedido y se ven en el panel, en
  // «Detalles adicionales», pero no en el carrito ni en el checkout. El
  // nombre no va: no sale nunca del navegador.
  function respuestasEnTexto() {
    var partes = [];
    var f = focoDe(st.foco);
    if (f) partes.push('Prioridad: ' + f.answer);
    if (enRuta(2)) {
      var b = baseDe(st.base);
      partes.push('Base: ' + (b ? b.title : 'sin respuesta'));
    }
    if (enRuta(3)) {
      var sabores = st.boosters.map(function (h) { return PORHANDLE[h] ? PORHANDLE[h].title : h; });
      partes.push('Boosters: ' + (sabores.length ? sabores.join(', ') : 'ninguno'));
    }
    if (st.foco === 'energia') partes.push('Proteína: ' + (st.prot === 'si' ? 'sí' : 'no'));
    if (st.foco === 'fuerza') partes.push('Creatina: ' + (st.crea === 'si' ? 'sí' : 'no'));
    else if (st.foco) partes.push('Creatina: incluida');
    return partes.join(' · ');
  }

  function marcarCarrito(x) {
    var atributos = {
      'Quiz · match': x.r.ritual.name,
      'Quiz · respuestas': respuestasEnTexto(),
      'Quiz · productos': x.items.map(function (p) { return p.title; }).join(', '),
      // Sin parámetros de la dirección (utm, fbclid…): solo página y resultado.
      'Quiz · enlace': location.origin + location.pathname + location.hash
    };
    var envio = fetch(rutaBase() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: atributos })
    });
    var espera = new Promise(function (ok) { setTimeout(ok, 2500); });
    return Promise.race([envio, espera]);
  }

  function alCarrito(boton) {
    var x = ritualActual();
    var lista = x.c.pack
      ? [{ id: x.c.pack.id, quantity: 1 }]
      : x.items.map(function (p) { return { id: p.id, quantity: 1 }; });
    if (!lista.length) return;
    boton.disabled = true;
    evento('quiz_add_to_cart', { ritual: x.r.ritual.key, total: x.c.total / 100, bundle: x.c.pack ? x.c.pack.title : null });
    fetch(rutaBase() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lista })
    }).then(function (r) {
      if (!r.ok) throw new Error('carrito');
      // La marca del quiz nunca detiene la compra: si falla o tarda, se
      // sigue al carrito igual.
      return marcarCarrito(x).catch(function () {}).then(function () {
        location.href = datos.cart_url || '/cart';
      });
    }).catch(function () {
      boton.disabled = false;
      boton.insertAdjacentHTML('afterend', '<p class="am-rq__aviso" role="status">' + esc(C.r_cart_error) + '</p>');
    });
  }

  function compartir(boton) {
    var url = location.href;
    var x = ritualActual();
    evento('quiz_share', { ritual: x.r.ritual.key });
    if (navigator.share) {
      navigator.share({ title: x.r.ritual.name, url: url }).catch(function () { /* cancelar no es error */ });
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { boton.textContent = C.r_shared; });
    }
  }

  /* ---------------------------------------------------------------- navegar */

  function avanza() {
    st.dijo = '';
    st.paso = siguiente(st.paso);
    modo = 'push';
    pintar();
  }

  function tras(ms, fn) { setTimeout(fn, reduce ? 0 : ms); }

  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('button, [data-salir]');
    if (!b || b.disabled) return;

    if (b.hasAttribute && b.hasAttribute('data-salir')) {
      evento('quiz_exit', { paso: st.paso });
      return; // el enlace sigue su camino
    }

    if (b.dataset.pick != null) {
      var v = b.dataset.pick;
      if (st.paso === 1) { st.foco = v; st.dijo = frase(FOCOS, v); }
      else if (st.paso === 2) { st.base = v; st.dijo = frase(BASES, v); }
      else if (st.paso === 3) {
        if (v === 'nada') { st.boosters = []; st.nada = true; st.dijo = C.q3_none_say; }
        else if (v === 'todos') {
          // «Los tres»: marca los tres; si ya estaban, los desmarca.
          st.nada = false;
          if (st.boosters.length >= SABORES.length) { st.boosters = []; st.dijo = ''; }
          else { st.boosters = SABORES.map(function (c) { return c.handle; }); st.dijo = C.q3_all_say; }
        } else {
          st.nada = false;
          var i = st.boosters.indexOf(v);
          if (i > -1) { st.boosters.splice(i, 1); st.dijo = ''; }
          else { st.boosters.push(v); st.dijo = frase(CUIDADOS, v, 'handle'); }
        }
      } else if (st.paso === 4) { st.crea = v; st.dijo = v === 'si' ? C.c_yes_say : C.c_no_say; }
      else if (st.paso === 8) { st.prot = v; st.dijo = v === 'si' ? C.p_yes_say : C.p_no_say; }

      st.edit = null;
      // Respuestas nuevas, match nuevo: si antes dijo «Así está bien» a una
      // sugerencia, la del match nuevo vuelve a ofrecerse.
      st.sinSug = false;
      evento('quiz_answer', { pregunta: st.paso, respuesta: v });
      pintar();
      // Las preguntas de una sola respuesta avanzan solas: lo justo para ver
      // la frase y la capa nueva del vaso.
      var pasoElegido = st.paso;
      if (pasoElegido !== 3) tras(650, function () { if (st.paso === pasoElegido) avanza(); });
      return;
    }

    switch (b.dataset.nav) {
      case 'empezar':
        st.paso = 1; modo = 'push'; evento('quiz_start', { origen: document.referrer || 'directo' }); pintar(); return;
      case 'seguir': avanza(); return;
      case 'atras':
        evento('quiz_back', { pregunta: anterior(st.paso) });
        // Si el paso anterior está en el historial, se vuelve por él: así el
        // «Atrás» de la pantalla y el del navegador llevan al mismo sitio.
        if (indice > 0) { history.back(); return; }
        st.dijo = ''; st.paso = anterior(st.paso); st.edit = null;
        pintar(); return;
      case 'ver': avanza(); return;
      case 'sin-sug': st.sinSug = true; pintar(); return;
      case 'ajustar': st.sheet = true; pintarSheet(); return;
      case 'cerrar-ajuste': cerrarHoja(); return;
      case 'compartir': compartir(b); return;
      case 'reiniciar':
        st = estadoInicial();
        contado = false;   // el siguiente resultado también se cuenta
        pintar();
        return;
    }

    if (b.dataset.sumar) {
      st.edit = st.edit.concat([b.dataset.sumar]);
      evento('quiz_suggestion', { producto: b.dataset.sumar, aceptada: true });
      pintar();
      return;
    }

    if (b.dataset.toggle) {
      var h = b.dataset.toggle, k = st.edit.indexOf(h);
      if (k > -1 && st.edit.length === 1) return; // nunca un match vacío
      if (k > -1) st.edit.splice(k, 1); else st.edit.push(h);
      evento('quiz_edit', { cambio: k > -1 ? 'quitar' : 'anadir', producto: h });
      pintarSheet();
      return;
    }

    if (b.dataset.swap) {
      var nuevo = b.dataset.swap;
      st.edit = st.edit.map(function (x) { return PORHANDLE[x] && PORHANDLE[x].tipo === 'base' ? nuevo : x; });
      evento('quiz_edit', { cambio: 'base', producto: nuevo });
      if (st.sheet) pintarSheet(); else pintar();
      return;
    }

    if (b.hasAttribute('data-add')) alCarrito(b);
  });

  // Cerrar la hoja tocando el fondo o con Escape.
  raiz.addEventListener('click', function (ev) {
    if (ev.target.hasAttribute && ev.target.hasAttribute('data-cerrar-fondo')) cerrarHoja();
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && st.sheet) cerrarHoja();
  });

  function frase(lista, valor, campo) {
    var o = lista.filter(function (x) { return x[campo || 'key'] === valor; })[0];
    return (o && o.say) || '';
  }

  /* -------------------------------------------------------------- arranque */

  leer();
  medirArriba();
  pintar();
})();
